var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed bottom-0 left-0 right-0 z-999"},[_c('div',{staticClass:"center flex items-stretch tc shadow-5 br2 br--top overflow-hidden",class:{
      'bg-purple': _vm.brand === 'lh',
      'bg-yellow': _vm.brand === 'lq',
    },staticStyle:{"max-width":"72rem"}},[_c('router-link',{staticClass:"link w-25 pv4 f6 f5-l fw6 tracked lh-solid nowrap bg-animate br b--black-10",class:{
        'white': _vm.brand === 'lh',
        'dark-gray': _vm.brand === 'lq',
        'bg-black-20': _vm.brand === 'lh' && _vm.$route.name === 'development',
        'bg-dark-gray white': _vm.brand === 'lq' && _vm.$route.name === 'development'
      },attrs:{"to":'/developments/' + _vm.$route.params.id}},[_vm._v("\n      SITE PLAN\n    ")]),_c('router-link',{staticClass:"link w-25 pv4 f6 f5-l fw6 tracked lh-solid nowrap bg-animate br b--black-10",class:{
        'white': _vm.brand === 'lh',
        'dark-gray': _vm.brand === 'lq',
        'bg-black-20': _vm.brand === 'lh' && _vm.$route.name === 'local-information',
        'bg-dark-gray white': _vm.brand === 'lq' && _vm.$route.name === 'local-information'
      },attrs:{"to":'/developments/' + _vm.$route.params.id + '/local-information'}},[_vm._v("\n      LOCAL INFORMATION\n    ")]),_c('router-link',{staticClass:"link w-25 pv4 f6 f5-l fw6 tracked lh-solid nowrap bg-animate br b--black-10",class:{
        'white': _vm.brand === 'lh',
        'dark-gray': _vm.brand === 'lq',
        'bg-black-20': _vm.brand === 'lh' && _vm.$route.name.startsWith('about'),
        'bg-dark-gray white': _vm.brand === 'lq' && _vm.$route.name.startsWith('about')
      },attrs:{"to":'/developments/' + _vm.$route.params.id + '/about/company'}},[_vm._v("\n      ABOUT\n    ")]),_c('router-link',{staticClass:"link w-25 pv4 f6 f5-l fw6 tracked lh-solid nowrap bg-animate",class:{
        'white': _vm.brand === 'lh',
        'dark-gray': _vm.brand === 'lq',
        'bg-black-20': _vm.brand === 'lh' && _vm.$route.path === '/',
        'bg-dark-gray white': _vm.brand === 'lq' && _vm.$route.path === '/'
      },attrs:{"to":{name: 'developments', params: { focusId: _vm.$route.params.id } }}},[_vm._v("\n      DEVELOPMENTS\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }